import { css } from '@emotion/core';
import { mq } from '../../cssInJs';
export default {
  button: css(mq({
    position: 'absolute',
    zIndex: 999,
    top: '.6rem',
    left: '1rem',
    lineHeight: '1.6rem',
    color: '#243588',
    fontSize: ['12px', null, '15px']
  })),
}